var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCheckFilledGreen = function SvgIconCheckFilledGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.667 9.997c0-4.591 3.742-8.333 8.333-8.333s8.334 3.742 8.334 8.333-3.742 8.334-8.334 8.334-8.333-3.742-8.333-8.334"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#429D15",
    d: "M10 1.664c-4.591 0-8.333 3.742-8.333 8.333S5.409 18.331 10 18.331s8.334-3.742 8.334-8.334S14.592 1.664 10 1.664m3.984 6.417-4.725 4.725a.624.624 0 0 1-.884 0l-2.358-2.359a.63.63 0 0 1 0-.883.63.63 0 0 1 .883 0l1.917 1.917L13.1 7.197a.63.63 0 0 1 .884 0 .63.63 0 0 1 0 .884"
  })));
};
export default SvgIconCheckFilledGreen;